import styled from 'styled-components'

export const StyledNewsArticleActions = styled.div`
  display: flex;
  column-gap: 5px;
`
